import {Injectable} from '@angular/core';
import {ProductStockUnitSummaryModel} from "../productStockUnitSummary.model";
import {ProductSummaryConverter} from "../../../../../api/entity/converter/productSummary.converter";
import {HttpModelConverter} from "../../../../../../core/converter/httpModel.converter";
import {DateConverter} from "../../../../../../common/converter/date.converter";
import {ProductStockUnitModel} from "../productStockUnit.model";
import {ProductStockUnitSummaryConverter} from "./productStockUnitSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class ProductStockUnitConverter extends HttpModelConverter<ProductStockUnitModel> {

    constructor(private productSummaryConverter: ProductSummaryConverter,
                private summaryConverter: ProductStockUnitSummaryConverter) {
        super();
    }

    protected createInstance(): ProductStockUnitModel {
        return new ProductStockUnitModel();
    }

    protected enrichObject(result: ProductStockUnitModel, src: ProductStockUnitModel) {
        result.product = this.productSummaryConverter.convert(src.product);
        result.summary = this.summaryConverter.convert(src.summary);
    }

}
